import { Colors } from "@/enums/Colors";
import { mapToShell } from "@/models/ai-chat/LazoChatConversation";
import LazoChatConversationService from "@/services/ai-chat/LazoChatConversationService";
import { Box, CircularProgress } from "@mui/material";
import { useEffect } from "react";
import { usePortalChatContext } from "./PortalChatContext";
import PortalChatMessageList from "./PortalChatMessageList";
import { Conversation } from "./PortalInboxStatistics";

interface Props {
  selectedConversation: Conversation;
}
const PortalInboxStatisticsReadConversation = ({ selectedConversation }: Props) => {
  const {
    loadingMessages,
    messages,
    setChats,
    selectedChat,
    fetchMoreMessages,
    userExternalIdToTenantNamesMap,
    setSelectedChat,
    firstLoadMessages,
  } = usePortalChatContext();

  useEffect(() => {
    if (selectedConversation) {
      LazoChatConversationService.getInternalChat(selectedConversation.externalId).then((r) => {
        r.onSuccess(() => {
          const data = r.getContentOrThrowError();
          setSelectedChat(mapToShell(data));
        });
      });
    } else {
      setSelectedChat(null);
    }
  }, [selectedConversation]);

  return (
    <>
      {firstLoadMessages || !selectedChat ? (
        <Box sx={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <CircularProgress size={40} sx={{ color: Colors.LAZO_PURPLE }} role="status" />
        </Box>
      ) : (
        <PortalChatMessageList
          loadingMessages={loadingMessages}
          messages={messages}
          conversation={selectedChat}
          openSettings={false}
          setOpenSettings={() => {}}
          onChatSelect={() => {}}
          setChats={setChats}
          fetchMoreMessages={fetchMoreMessages}
          userExternalIdToTenantNamesMap={userExternalIdToTenantNamesMap}
        />
      )}
    </>
  );
};

export default PortalInboxStatisticsReadConversation;
